import { Quill } from "vue2-editor";

const levels = [1, 2, 3, 4, 5, 6, 7, 8];
const multiplier = 3;

class IndentAttributor extends Quill.import('parchment').Attributor.Style {
    constructor(name: string, style: string, params: any) {
        super(name, style, params);
    }
  
    add(node: any, value: any) {
		return super.add(node, `${value * multiplier}em`);
	}

	value(node: any) {
		return parseFloat(super.value(node)) / multiplier || undefined; // Don't return NaN
	}
}

export const IndentStyle = new IndentAttributor('indent', 'text-indent', {
    scope: Quill.import('parchment').Scope.BLOCK,
    whitelist: levels.map(value => `${value * multiplier}em`)
  })

export const AlignStyle = Quill.import('attributors/style/align');